<template>
  <global-widget-banner
    v-if="globalWidget.type === GLOBAL_WIDGET_TYPES.BANNER && !isDismissed"
    :header-content="globalWidget.config.bannerHeaderContent"
    :header-text-align="globalWidget.config.bannerHeaderTextAlign"
    :header-link-type="globalWidget.config.bannerHeaderLinkableType"
    :header-link-url="globalWidget.bannerHeaderLinkUrl"
    :body-content="globalWidget.config.bannerBodyContent"
    :body-text-align="globalWidget.config.bannerBodyTextAlign"
    :body-link-type="globalWidget.config.bannerBodyLinkableType"
    :body-link-url="globalWidget.bannerBodyLinkUrl"
    :background-color="globalWidget.config.bannerBackgroundColor"
    :background-color-hex="globalWidget.config.bannerBackgroundColorHex"
    :show-icon="globalWidget.config.bannerShowIcon"
    :icon-name="globalWidget.config.bannerIconName"
    :is-dismissable="globalWidget.config.isDismissable"
    :is-full-width="globalWidget.config.bannerIsFullWidth"
    :is-editing="isEditing"
    @dismiss="dismiss"
  />
</template>

<script>
import { Cookies } from 'quasar'
import GlobalWidget, { GLOBAL_WIDGET_TYPES, RESTORATION_FREQUENCY_OPTIONS } from 'src/models/global-widget/GlobalWidget'
import GlobalWidgetBanner from 'src/modules/consumer/components/GlobalWidgetBanner'

function globalWidgetDismissedCookie (globalWidget) {
  return `globalWidget${globalWidget.id}Dismissed`
}

function setGlobalWidgetDismissed (globalWidget) {
  if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_DAY) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 1 })
  } else if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_WEEK) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 7 })
  } else if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_MONTH) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 30 })
  } else if (globalWidget.config.restorationFrequency === RESTORATION_FREQUENCY_OPTIONS.EVERY_YEAR) {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: 365 })
  } else {
    Cookies.set(globalWidgetDismissedCookie(globalWidget), { expires: -1 })
  }
}

function isGlobalWidgetDismissed (globalWidget) {
  return Cookies.has(globalWidgetDismissedCookie(globalWidget))
}

export default {
  name: 'GlobalWidget',
  components: {
    GlobalWidgetBanner
  },
  props: {
    globalWidget: {
      type: GlobalWidget,
      required: true
    },
    isEditing: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['sync'],
  data (props) {
    return {
      isDismissed: isGlobalWidgetDismissed(props.globalWidget)
    }
  },
  created () {
    _.extend(this, { GLOBAL_WIDGET_TYPES })
  },
  methods: {
    dismiss () {
      this.isDismissed = true

      if (this.isEditing) return

      setGlobalWidgetDismissed(this.globalWidget)
      this.$emit('sync')
    },
    syncDismissedState () {
      this.isDismissed = isGlobalWidgetDismissed(this.globalWidget)
    }
  }
}
</script>
